/* eslint-disable local/ensure-wac-token-usage */

// custom colors that are not covered by wacToken
export const colors = {
    black: "#000000",
    elevationSurfaceSunken: "#F7F8F9",
    text: "#172B4D",
    textSelected: "#0C66E4",
    textSubtle: "#44546F"
};
